import { Injectable } from "@angular/core";
import { RequestService, StorageService, GlobalState } from "../../common";
import { Utils } from "../../common/utils";
import {
  INVARIANT,
  HOME_TEM_MAIN,
  HOME_TEM_SECOND,
  HOME_TEM_LIST,
  BIZ_CACHE_TABLE,
} from "../../../config";

@Injectable()
export class CacheDataService {
  constructor(
    private requestSer: RequestService,
    private storageSer: StorageService,
    private global: GlobalState,
    private util: Utils,
  ) {}

  /**
   * 缓存应用系统数据 于用户不强关联的
   * @param cacheVersions 缓存版本号 与配置文件中BIZ_CACHE_TABLE dic_id对应
   */
  cacheSysDatas(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestSer
        .httpRequest("QUERY_SYSTEMDATAS_VERSION", "", false)
        .subscribe(
          (res) => {
            if (res && res.code == "200") {
              const { codeList, ecClaimType, mdDistrict } = res.datas; //获取所有需要缓存的版本号 并赋值给cacheVersion
              const cacheVersion = {};
              cacheVersion["codeList"] = codeList;
              cacheVersion["ecClaimType"] = ecClaimType;
              cacheVersion["mdDistrict"] = mdDistrict;
              const requestArr = [];
              BIZ_CACHE_TABLE.forEach((cache) => {
                cache.cache_flag &&
                  requestArr.push(this.handleReq(cache, cacheVersion));
              });
              Promise.all(requestArr).then(
                (resultArr) => {
                  console.log(resultArr);
                  resolve(resultArr);
                },
                (err) => {
                  //有一个请求失败都会直接失败 需要重新缓存 但是成功的请求已经保存在本地 不会二次请求
                  console.log(err);
                  reject(false);
                },
              );
            } else {
              reject(res);
            }
          },
          (error) => reject(error),
        );
    });
  }

  /**
   * 获取单系统数据
   * @param cache 需要缓存的系统参数配置
   * @param cacheVersions 缓存版本号 与配置文件中BIZ_CACHE_TABLE dic_id对应
   */
  handleReq(cache, cacheVersions): Promise<any> {
    const { doc_id, interface_method, local_key, global_key } = cache;
    return new Promise((resolve, reject) => {
      this.storageSer
        .getStore(INVARIANT[local_key])
        .then(
          (localCache) => {
            if (
              localCache &&
              localCache != null &&
              localCache.versionNo == cacheVersions[doc_id]
            ) {
              console.log(`${global_key}-global---`, localCache.datas);
              global_key && this.global.set(global_key, localCache.datas);
              return resolve(true);
            }
            this.requestSer
              .httpRequest(interface_method, "", false)
              .subscribe((res) => {
                if (res && res.code == 200) {
                  const saveLocalCL = {
                    versionNo: cacheVersions[doc_id],
                    datas: {},
                  };
                  saveLocalCL.datas = res.datas;
                  this.storageSer.setStore(INVARIANT[local_key], saveLocalCL);
                  console.log(`${global_key}-global---`, saveLocalCL.datas);
                  this.global.set(global_key, saveLocalCL.datas);
                  return resolve(res);
                } else {
                  return reject(res);
                }
              });
          },
          (err) => reject(err),
        )
        .catch((err) => reject(err));
    });
  }

  /**
   * 初始化首页展示效果
   * @param userid 用户id
   */
  initHomeTem(userid): Promise<any> {
    return new Promise((resolve, reject) => {
      this.requestSer.httpRequest("QUERY_HOME_TEMINIT", "").subscribe(
        (res) => {
          console.log(res);
          const { code, datas } = res;
          if (code == "200") {
            this.storageSer
              .getUserStore(userid, INVARIANT._USER_ISSHOWHOMETEM)
              .then((showHomeTem) => {
                const initDatas = datas.map((d) => {
                  return {
                    ...d,
                    id: d.id,
                    parentId: d.parentId,
                    title: d.titleName,
                    pageName: d.url,
                    imgUrl: d.menulogo
                      ? `assets/imgs/${d.menulogo}`
                      : `assets/imgs/mr.png`,
                    className: `icon-box bg-d`, //需要一个背景颜色
                    isAdded: false,
                    lastFlag: d.lastFlag,
                  };
                });
                console.log(initDatas, showHomeTem);
                if (showHomeTem) {
                  //展示首页2
                  this.global.set("showTemHome", true);
                } else {
                  //展示首页1
                  this.global.set("showTemHome", false);
                }
                //初始化首页1
                const resultArr = this.util.listToTree(initDatas);
                console.log(resultArr);
                if (resultArr == false) return reject(false);
                this.global.set("homeFirstTem", resultArr.children);
                //初始化首页2
                this.storageSer
                  .getUserStore(userid, INVARIANT._USER_SHOWHOMTEM)
                  .then((res) => {
                    if (res == null) {
                      const mainTem = initDatas.filter(
                        (d) => d.lastFlag == "1",
                      );
                      const homeSecondTem = {
                        main: mainTem,
                        second: HOME_TEM_SECOND.filter((d) => !d.disabled),
                        list: HOME_TEM_LIST.filter((d) => !d.disabled),
                      };
                      this.storageSer.setUserStore(
                        userid,
                        INVARIANT._USER_SHOWHOMTEM,
                        homeSecondTem,
                      );
                      this.global.set("homeSecondTem", homeSecondTem);
                    } else {
                      this.global.set("homeSecondTem", res);
                    }
                    resolve(true);
                  });
              });
          } else {
            reject(res);
          }
        },
        (error) => reject(error),
      );
    });
  }

  /**
   * 获取local城市数据
   */
  public getInlandCitys(countryId): Promise<any> {
    return new Promise((resolve, reject) => {
      this.storageSer
        .getStore(INVARIANT._SYS_AREADATAS)
        .then(
          (res) => {
            const treeData = this.util.listToTreeForCountry(
              res.datas,
              countryId,
            );
            console.log(treeData);
            resolve(treeData);
          },
          (err) => reject(err),
        )
        .catch((err) => reject(err));
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/business/cache-data/cache-data.service.ts